import { ReactElement, useMemo, memo } from 'react';
import { Typography, Stack, Chip, CardActions, Button } from '@mui/material';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import { getCustomerIdentifier } from '~utils/customer';

import { DialogSearchCustomersListItemProps } from './types';
import {
  DialogSearchCustomersListCardItem,
  DialogSearchCustomersListCardItemContent,
} from './styles';

const DialogSearchCustomersListItem = ({
  data,
  currentSearch,
  onSelect,
}: DialogSearchCustomersListItemProps): ReactElement => {
  const descriptionParts = useMemo(() => {
    const description = getCustomerIdentifier(data);

    const matches = match(description, currentSearch, { insideWords: true });

    const parts = parse(description, matches);

    return parts;
  }, [currentSearch, data]);

  return (
    <DialogSearchCustomersListCardItem variant="outlined">
      <DialogSearchCustomersListCardItemContent>
        <Stack direction="row" spacing={0.5}>
          <Typography component="p" variant="body2">
            {descriptionParts.map((part, index) => (
              <span
                key={index}
                style={{ fontWeight: part.highlight ? 700 : 400 }}
              >
                {part.text}
              </span>
            ))}
          </Typography>

          {data.customerType && <Chip label={data.customerType} size="small" />}
        </Stack>

        <Typography component="p" variant="body2">
          {data.address}
        </Typography>
      </DialogSearchCustomersListCardItemContent>

      <CardActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onSelect(data)}
        >
          Seleccionar
        </Button>
      </CardActions>
    </DialogSearchCustomersListCardItem>
  );
};

export default memo(DialogSearchCustomersListItem);
